import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUtilityContext } from '../../../utility-provider';
import { encryptQueryParam, decryptQueryParam } from '../../../utility/util';
import { useUserContext } from '../../../user-provider';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { setConfirmationData } from '../../../features/trafficConfirmationScreenSlice';
import { getMultipleData } from "../../../api/DataManage"
import dayjs from "dayjs"
import { setReceptionBook } from '../../../features/receptionBookSlice';
import { userLogging } from '../../../utility/firestore';
import { LOCAL_CONSTANT } from '../../common/Const';
import ConfirmDialog from '../../common/ConfirmDialog';

import {
    Box,
    FormControlLabel,
    RadioGroup,
    Radio,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";

const buttonShortStyle = {
    minWidth: 0,
    padding: "2px 6px",
    margin: '2px 4px',
    border: '1px solid blue'
}

const buttonStyle = {
    minWidth: 0,
    padding: "2px 2px",
    margin: '2px 4px',
    border: '1px solid blue'
}


const headerRowStyle = () => {
    return {
        position: "sticky",
        top: 0,
        background: '#ccc',
        zIndex: 2,
        borderBottom: '2px solid #000',
    }
}

const headCrossStyle = (params: any) => {
    return {
        position: "sticky",
        left: 0,
        background: '#ccc',
        zIndex: 1,
        width: params.width + 'px',
        minWidth: params.width + 'px',
        maxWidth: params.width + 'px',
        borderRight: '2px solid #000',
        borderBottom: '2px solid #000',
    }
}

const headColStyle = (params: any) => {
    return {
        textAlign: 'center',
        width: params.width + 'px',
        minWidth: params.width + 'px',
        maxWidth: params.width + 'px',
        borderLeft: params.bl ? '2px solid #000' : '1px solid #000',
        borderBottom: params.bb ? '2px solid #000' : '1px solid #000',
    }    
}


const rowColStyle = (params: any) => {
    return {
        lineHeight: '50px',
        height: '50px',
        textAlign: 'center',
        borderLeft: params.bl ? '2px solid #000' : '1px solid #000',
    }
}

const rowCrossStyle = (params: any) => {
    return {
        position: "sticky",
        left: 0,
        zIndex: 1,
        background: '#ccc',
        borderRight: params.br ? '2px solid #000' : '1px solid #000',
    }
}

const list = {
    id: "",
    create_date: "",
    update_date: "",
    delete_flag: "",
    plan_area_id: "",
    count_date: '',
    count_time: '',
    count_afterTime: '',
    timeZone: '',
    count_type: '',
    car_total: '',
    front_traffic_jam_time: '',
    frontTotal: '',
    car_front_light: '',
    car_front_large: '',
    side_a_traffic_jam_time: "",
    car_side_a_total: '',
    car_side_a_light: '',
    car_side_a_large: '',
    car_side_b_total: '',
    car_side_b_light: '',
    car_side_b_large: '',
    car_back_total: '',
    car_back_light: '',
    car_back_large: '',
    male_65over: '',
    female_65over: '',
    male_other: '',
    female_other: '',
    student: '',
    bicycle: '',
    total_people: ''
}

export interface resultProps {
    props:{
    }
}

const TrafficConfirmationScreen:React.FC<resultProps> = ({props}) => {
    const utilityCtx = useUtilityContext();
    const user = useUserContext();
    const navigate = useNavigate();

    const dispatch = useAppDispatch();
    const objTcsData = useAppSelector((state) => state.trafficConfirmationScreenData);
    // 受付簿
    const objReceptionBook = useAppSelector((state) => state.receptionBook.select);
    //URLパラメータ
    const [planAreaId, setPlanAreaId] = useState("");
    // ダイアログ開閉フラグ
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);

    // Display time period
    const [menuWidth, setMenuWidth] = useState(0)
    const [sortWidth, setSortWidth] = useState(0)
    const [displayTimePeriod, setDisplayTimePeriod] = useState(0)
    const [viewDetails, setViewDetails] = useState(0)
    const [tilt, setTilt] = useState<boolean>(false)

    const [openSort, setOpenSort] = useState<boolean>(false)
    const [openDisplayTime, setOpenDisplayTime] = useState<boolean>(false)
    const [openDetailItems, setOpenDetailItems] = useState<boolean>(false)
    // ソート
    const [sortValue, setSortValue] = useState<string>('0')
    const [tableWidth, setTableWidth] = useState("100%")
    const [tableHeight, setTableHeight] = useState("0")

    //ユーザー取得タイミングによる画面制御
    useEffect(() => {
        if (JSON.parse(user.userData || 'null') !== null) {
            if (planAreaId) {
                getTrafficVolumeList()
            }
        }
    }, [user, planAreaId]);

    const [dataList, setDataList] = useState([])
    const [datarows, setDatarows] = useState([])
    
    const getTrafficVolumeList = () => {
        if (planAreaId) {
            if (utilityCtx.showSpinner) {
                utilityCtx.showSpinner()
            }
            callApi()
                .then((res: any) => {
                    dispatch(setReceptionBook({
                        ...objReceptionBook,
                        plan_area_id: res.planAreaSearchById[0]["plan_area_id"],
                        plan_area_name: res.planAreaSearchById[0]["plan_area_name"]
                    }))
                    const tmpList: any = []
                    // 日付でソート
                    res.getTrafficVolume.sort((a: any, b: any) => Date.parse(b.count_date) - Date.parse(a.count_date) )
                    res.getTrafficVolume.map((row: any) => {
                        const timeZone = getTimeZone(row)
                        const tmp = JSON.parse(JSON.stringify(list))
                        tmp.id = row.uuid
                        tmp.create_date = row.create_date
                        tmp.update_date = row.update_date
                        tmp.delete_flag = row.delete_flag
                        tmp.plan_area_id = row.plan_area_id
                        tmp.sort_count_date = row.count_date
                        tmp.count_date = dayjs(row.count_date).format('YYMMDD')
                        tmp.count_time = dayjs(row.count_date).format('HHmm')
                        tmp.count_time_display = dayjs(row.count_date).format('HH:mm')
                        tmp.count_afterTime = dayjs(row.count_date).add(row.count_time, "m").format('HHmm')
                        tmp.timeZone = timeZone
                        tmp.count_type = row.count_type
                        tmp.car_total = (
                            row.car_front_standard + row.car_front_light + row.car_front_large +
                            row.car_side_a_standard + row.car_side_a_light + row.car_side_a_large +
                            row.car_side_b_standard + row.car_side_b_light + row.car_side_b_large +
                            row.car_back_standard + row.car_back_light + row.car_back_large
                        )
                        tmp.front_traffic_jam_time = row.front_traffic_jam_time
                        tmp.frontTotal = row.car_front_standard + row.car_front_light + row.car_front_large
                        tmp.car_front_light = row.car_front_light
                        tmp.car_front_large = row.car_front_large
                        tmp.side_a_traffic_jam_time = row.side_a_traffic_jam_time
                        tmp.car_side_a_total = row.car_side_a_standard + row.car_side_a_light + row.car_side_a_large
                        tmp.car_side_a_light = row.car_side_a_light
                        tmp.car_side_a_large = row.car_side_a_large
                        tmp.car_side_b_total = row.car_side_b_standard + row.car_side_b_light + row.car_side_b_large
                        tmp.car_side_b_light = row.car_side_b_light
                        tmp.car_side_b_large = row.car_side_b_large
                        tmp.car_back_total = row.car_back_standard + row.car_back_light + row.car_back_large
                        tmp.car_back_light = row.car_back_light
                        tmp.car_back_large = row.car_back_large
                        tmp.male_65over = row.people_5m_in_male_65over + row.people_5m_out_male_65over
                        tmp.female_65over = row.people_5m_in_female_65over + row.people_5m_out_female_65over
                        tmp.male_other = row.people_5m_in_male_other + row.people_5m_out_male_other
                        tmp.female_other = row.people_5m_in_female_other + row.people_5m_out_female_other
                        tmp.student = row.people_5m_in_student + row.people_5m_out_student
                        tmp.bicycle = row.people_5m_in_bicycle + row.people_5m_out_bicycle
                        tmp.total_people = (
                            row.people_5m_in_male_65over + row.people_5m_out_male_65over +
                            row.people_5m_in_female_65over + row.people_5m_out_female_65over +
                            row.people_5m_in_male_other + row.people_5m_out_male_other +
                            row.people_5m_in_female_other + row.people_5m_out_female_other +
                            row.people_5m_in_student + row.people_5m_out_student
                        )
                        tmpList.push(tmp)

                        return tmpList
                    })
                    setDataList(tmpList)
                    setDatarows(tmpList)
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                })
        }
    }


    const callApi = async () => {
        const param: any = []
        const jsonUserData = JSON.parse(user.userData);
        let manageCitiesFlg = true
        if (jsonUserData.administrator_flag === "1" || jsonUserData.manage_cities?.includes("ALL")) {
            manageCitiesFlg = false;
        }
        const manage_steps = ['0', '8', '99']
        let stepCnt = jsonUserData.manage_steps.filter(
            (val: any) => manage_steps.includes(val) === false
        );
        let managePlansOutsideCities = jsonUserData.manage_plans_outside_cities;
        if (!managePlansOutsideCities.includes("")) {
            managePlansOutsideCities.push("");
        }
        param.push({
            mode: "planAreaSearchById",
            id: planAreaId,
            manageCitiesFlg: manageCitiesFlg,
            manageCities: jsonUserData.manage_cities.join(','),
            manageStep: stepCnt.join(','),
            managePlansOutsideCities: managePlansOutsideCities.join(','),
        })
        param.push({
            mode: 'getTrafficVolume',
            plan_area_id: planAreaId,
            count_type: ['0','1','2']
        })
        return await getMultipleData(param)
    }


    useEffect(() => {
        windowTile();
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        //暗号化されたクエリパラメータを復号化
        const search = window.location.search;
        const urlParam = search.substring(1);
        decryptQueryParam(urlParam).then((res) => {
            if (res[0] && res[0].trim() !== '') {
                setPlanAreaId(res[0]);
                
                // 画面表示 userLogging
                if (user.userData) {
                    const decryptedUrl = window.location.pathname + `?planAreaId=${res[0]}`;
                    const encryptedUrl = window.location.pathname + window.location.search;
                    userLogging(
                        LOCAL_CONSTANT.FUNCTION_NAME.TRAFFIC_CONFIRMATION_DISPLAY,
                        {
                            decrypted_url: decryptedUrl,
                            encrypted_url: encryptedUrl
                        },
                        user
                    );
                }
            } else {
                // planAreaIdが存在しない場合はダイアログを表示
                setErrorDialogOpen(true);
            }
        }).catch((e:any) => {
            console.log(e);
            // 復号化エラーの場合もダイアログを表示
            setErrorDialogOpen(true);
        }).finally(() => {
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    }, []);

    // 端末の傾きを検知する
    window.addEventListener("orientationchange", () => {
        windowTile()
    });

    const windowTile = () => {
        var direction = Math.abs(window.screen.orientation.angle);
        let width = window.screen.width
        let height = window.screen.height
        let tilt = false
        setTableWidth('96%')
        if (direction === 0) {
            // 縦
            if (width > height) {
                width = window.screen.height
                height = window.screen.width
            }
            tilt = false
        } else if (direction === 90) {
            if (width > height) {
                width = window.screen.height
                height = window.screen.width
            }
            tilt = true
        } else if (width > height) {
            width = window.screen.height
            height = window.screen.width
            tilt = true
        }
        let tmp_sortWidth = Math.floor(width)
        let tmp_displayTimePeriod = Math.floor(width)
        let tmp_viewDetails = Math.floor(width)
        let menuWidth = width
        let tableHeight = Math.floor(height * 0.8) + "px"
        if (tilt) {
            // 横向きの処理
            tilt = true
            tmp_sortWidth = 130
            tmp_displayTimePeriod = 110
            tmp_viewDetails = 110
            menuWidth = 600
            tableHeight = Math.floor(height * 0.46) + "px"
            setTableWidth('97%')
        }

        setTilt(tilt)
        setSortWidth(tmp_sortWidth)
        setDisplayTimePeriod(tmp_displayTimePeriod)
        setViewDetails(tmp_viewDetails)
        setMenuWidth(menuWidth)
        setTableHeight(tableHeight)
        if (tilt) {
            changeMenuWidth(tmp_sortWidth, tmp_displayTimePeriod, tmp_viewDetails, openSort, openDisplayTime, openDetailItems)
        }
    }

    // ヘッダーイベント
    const handleSortHeader = () => {
        setOpenSort(!openSort)
        changeMenuWidth(sortWidth, displayTimePeriod, viewDetails, !openSort, openDisplayTime, openDetailItems)
    }
    const handleDisplayTime = () => {
        setOpenDisplayTime(!openDisplayTime)
        changeMenuWidth(sortWidth, displayTimePeriod, viewDetails, openSort, !openDisplayTime, openDetailItems)
    }
    const handleDetailItems = () => {
        setOpenDetailItems(!openDetailItems)
        changeMenuWidth(sortWidth, displayTimePeriod, viewDetails, openSort, openDisplayTime, !openDetailItems)
    }
    // ソートイベント

    // 詳細表示イベント
    const handleDetail = (target: string) => {
        let hasCarItem = objTcsData.carItem
        let hasPersonItem = objTcsData.personItem
        let hasMorning = objTcsData.morning
        let hasAfternoon = objTcsData.afternoon
        let hasNight = objTcsData.night
        let hasHoliday = objTcsData.holiday
        let hasMorningSpecific = objTcsData.morningSpecific
        let hasAfternoonSpecific = objTcsData.afternoonSpecific
        let hasNightSpecific = objTcsData.nightSpecific
        switch (target) {
            case "car":
                hasCarItem = !objTcsData.carItem
                break;
            case "person":
                hasPersonItem = !objTcsData.personItem
                break;
            case "morning":
                hasMorning = !objTcsData.morning
                break;
            case "afternoon":
                hasAfternoon = !objTcsData.afternoon
                break;
            case "night":
                hasNight = !objTcsData.night
                break;
            case "holiday":
                hasHoliday = !objTcsData.holiday
                break;
            case "morningSpecific":
                hasMorningSpecific = !objTcsData.morningSpecific
                break;
            case "afternoonSpecific":
                hasAfternoonSpecific = !objTcsData.afternoonSpecific
                break;
            case "nightSpecific":
                hasNightSpecific = !objTcsData.nightSpecific
                break;
        }
        // データ表示非表示
        const tmpList: any = []
        setDatarows(tmpList)
        dataList.map((row: any) => {
            if (
                hasMorning ||
                hasAfternoon ||
                hasNight ||
                hasHoliday ||
                hasMorningSpecific ||
                hasAfternoonSpecific ||
                hasNightSpecific
            ) {
                switch (row.timeZone) {
                    case 'morning':
                        if (hasMorning) {
                            tmpList.push(row)
                        }
                        break;
                    case 'afternoon':
                        if (hasAfternoon) {
                            tmpList.push(row)
                        }
                        break;
                    case 'night':
                        if (hasNight) {
                            tmpList.push(row)
                        }
                        break;
                    case 'holiday':
                        if (hasHoliday) {
                            tmpList.push(row)
                        }
                        break;
                    case 'morningSpecific':
                        if (hasMorningSpecific) {
                            tmpList.push(row)
                        }
                        break;
                    case 'afternoonSpecific':
                        if (hasAfternoonSpecific) {
                            tmpList.push(row)
                        }
                        break;
                    case 'nightSpecific':
                        if (hasNightSpecific) {
                            tmpList.push(row)
                        }
                        break;
                    case 'afternoon_holiday':
                        if (hasAfternoon || hasHoliday) {
                            tmpList.push(row)
                        }
                        break;
                    case 'holiday_afternoonSpecific':
                        if (hasHoliday || hasAfternoonSpecific) {
                            tmpList.push(row)
                        }
                        break;
                    case 'holiday_nightSpecific':
                        if (hasHoliday || hasNightSpecific) {
                            tmpList.push(row)
                        }
                        break;
                }
            } else {
                // 表示時間帯絞り込み無し
                tmpList.push(row)
            }
            return row
        })
        setDatarows(tmpList)
        dispatch(setConfirmationData({
            ...objTcsData,
            carItem: hasCarItem,
            personItem: hasPersonItem,
            morning: hasMorning,
            afternoon: hasAfternoon,
            night: hasNight,
            holiday: hasHoliday,
            morningSpecific: hasMorningSpecific,
            afternoonSpecific: hasAfternoonSpecific,
            nightSpecific: hasNightSpecific,
        }))
        // ソート
        sortList(sortValue, tmpList)
    }

    const getTimeZone = (trafficData: any) => {
        const beforTime = Number(dayjs(trafficData.count_date).format('HHmm'))
        const afterTime = Number(dayjs(trafficData.count_date).add(trafficData.count_time, "m").format('HHmm'))
        let timeZone = ""
        if (trafficData.count_type === "1") {
            // 車のみ
            if ((beforTime >= 900 && afterTime <= 1030)) {
                timeZone = 'morning'
            } else if ((beforTime >= 1300 && afterTime <= 1500)) {
                timeZone = 'afternoon'
            } else if ((beforTime >= 2000 && afterTime <= 2130)) {
                timeZone = 'night'
            } else if ((beforTime >= 1030 && afterTime <= 1630)) {
                timeZone = 'holiday'
            }
        } else {
            if ((beforTime >= 900 && afterTime <= 1030)) {
                timeZone = 'morning'
            } else if (
                (beforTime >= 1300 && afterTime <= 1500) &&
                (beforTime >= 1030 && afterTime <= 1630)
            ) {
                timeZone = 'afternoon_holiday'
            } else if (
                (beforTime >= 1030 && afterTime <= 1630) &&
                (beforTime >= 1200 && afterTime <= 1300)
            ) {
                timeZone = 'holiday_afternoonSpecific'
            } else if (
                (beforTime >= 1030 && afterTime <= 1630) &&
                (beforTime >= 1600 && afterTime <= 1730)
            ) {
                timeZone = 'holiday_nightSpecific'
            } else if ((beforTime >= 1300 && afterTime <= 1500)) {
                timeZone = 'afternoon'
            } else if ((beforTime >= 2000 && afterTime <= 2130)) {
                timeZone = 'night'
            } else if ((beforTime >= 1030 && afterTime <= 1630)) {
                timeZone = 'holiday'
            } else if ((beforTime >= 730 && afterTime <= 830)) {
                timeZone = 'morningSpecific'
            } else if ((beforTime >= 1200 && afterTime <= 1300)) {
                timeZone = 'afternoonSpecific'
            } else if ((beforTime >= 1600 && afterTime <= 1730)) {
                timeZone = 'nightSpecific'
            }
        }

        return timeZone
    }


    const handleRadioButtonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSortValue(e.target.value)
        sortList(e.target.value, datarows)
    }

    const sortList = (sortKey: string, data: any) => {
        switch (sortKey) {
            case "0":
                setDatarows(data.sort((a: any, b: any) => Date.parse(b.sort_count_date) - Date.parse(a.sort_count_date) ))
                break;
            case "1":
                setDatarows(data.sort((a: any, b: any) => b.car_total - a.car_total))
                break;
            case "2":
                setDatarows(data.sort((a: any, b: any) => b.total_people - a.total_people))
                break;
        }
    }

    const changeMenuWidth = (
        sortWidth: number,
        displayTimePeriod: number,
        viewDetails: number,
        openSort: boolean,
        openDisplayTime: boolean,
        openDetailItems: boolean
    ) => {
        let tmp_sortWidth = sortWidth
        let tmp_displayTimePeriod = displayTimePeriod
        let tmp_viewDetails = viewDetails
        if (openSort) {
            tmp_sortWidth = Math.floor(sortWidth * 2.4)
        }
        if (openDisplayTime) {
            tmp_displayTimePeriod = displayTimePeriod * 3
        }
        if (openDetailItems) {
            tmp_viewDetails = viewDetails
        }
        setMenuWidth((tmp_sortWidth + tmp_displayTimePeriod + tmp_viewDetails) - 20)
    }

    const sortWidthSize = () => {
        return {
            width: openSort && tilt ? Math.floor(sortWidth * 2.4) : sortWidth,
            minWidth: openSort && tilt ? Math.floor(sortWidth * 2.4) : sortWidth,
            maxWidth: openSort && tilt ? Math.floor(sortWidth * 2.4) : sortWidth
        }
    }

    const openDisplayTimeWidthSize = () => {
        return {
            width: openDisplayTime && tilt ? displayTimePeriod * 3 : displayTimePeriod,
            minWidth: openDisplayTime && tilt ? displayTimePeriod * 3 : displayTimePeriod,
            maxWidth: openDisplayTime && tilt ? displayTimePeriod * 3 : displayTimePeriod,
        }
    }

    const openDetailItemsWidthSize = () => {
        return {
            width: openDetailItems && tilt ? Math.floor(viewDetails * 1.5) : viewDetails,
            minWidth: openDetailItems && tilt ? Math.floor(viewDetails * 1.5) : viewDetails,
            maxWidth: openDetailItems && tilt ? Math.floor(viewDetails * 1.5) : viewDetails,
        }
    }

    const onClickHandle = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        const param = `planAreaId=${planAreaId}`;
        // URLパラメータ暗号化
        encryptQueryParam(param).then((res) => {
            const url = "/Planareamenu?" + res;
            navigate(url);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    }

    return (
        <Box sx={{ 
            width: "100%",
        }}>
            <Box sx={{
                margin: '4px 4px 10px 4px'
            }}>
                <Box sx={{
                    display: tilt ? 'flex' : 'block',
                }}>
                    <Box sx={{
                        display: 'flex',
                        marginRight: tilt ? '10px' : '0',
                    }}>
                        <Button
                            variant="outlined"
                            size="small"
                            sx={{margin: '0 4px 0 0', width: '30px', maxWidth: '30px', minWidth: '30px', padding: '10px 0',
                            height: '30px', maxHeight: '30px', minHeight: '30px',
                            boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
                            }}
                            onClick={(e) => {onClickHandle()}}
                        >≪</Button>
                        <Box sx={{ padding: '4px 0' }}>{objReceptionBook.plan_area_name}</Box>
                    </Box>
                    <Box sx={{
                        display: tilt ? 'flex' : 'block',
                        flexWrap: tilt ? 'nowrap' : 'wrap',
                        overflowX: tilt ? 'auto' : 'hidden',
                        width: tilt ? menuWidth : "100%",
                    }}>
                        <Box sx={sortWidthSize()}>
                            <Typography
                                onClick={(e) => {handleSortHeader()}}
                            >ソート（降順）▼</Typography>
                            <Box sx={{
                                display: openSort ? 'flex' : 'none',
                                width: openSort && tilt ? Math.floor(sortWidth * 2.4) : sortWidth
                            }}>
                                <RadioGroup
                                    row
                                    value={sortValue}
                                    onChange={(e) =>handleRadioButtonChange(e)}
                                >
                                    <FormControlLabel
                                        value={"0"}
                                        control={
                                            <Radio
                                                size="small"
                                            />
                                        }
                                        label={"調査日時"}
                                    />
                                    <FormControlLabel
                                        value={"1"}
                                        control={
                                            <Radio
                                                size="small"
                                            />
                                        }
                                        label={"車総台数"}
                                    />
                                    <FormControlLabel
                                        value={"2"}
                                        control={
                                            <Radio
                                                size="small"
                                            />
                                        }
                                        label={"人総数"}
                                    />
                                </RadioGroup>
                            </Box>
                        </Box>
                        <Box sx={openDisplayTimeWidthSize()}>
                            <Typography
                                onClick={(e) => {handleDisplayTime()}}
                            >表示時間帯▼</Typography>
                            <Box sx={{
                                display: openDisplayTime ? 'flex' : 'none',
                                width: openDisplayTime && tilt ? displayTimePeriod * 3 : displayTimePeriod
                            }}>
                                <Box sx={{
                                    '& .MuiButton-root:hover': {
                                        color: objTcsData.morning ? 'white' : 'black',
                                        backgroundColor: objTcsData.morning ? 'blue' : 'white',
                                    },
                                    '& .MuiButton-root': {
                                        color: objTcsData.morning ? 'white' : 'black',
                                        backgroundColor: objTcsData.morning ? 'blue' : 'white',
                                    }
                                }}><Button size="small" onClick={(e) => {handleDetail('morning')}} sx={buttonShortStyle}>朝</Button></Box>
                                <Box sx={{
                                    '& .MuiButton-root:hover': {
                                        color: objTcsData.afternoon ? 'white' : 'black',
                                        backgroundColor: objTcsData.afternoon ? 'blue' : 'white',
                                    },
                                    '& .MuiButton-root': {
                                        color: objTcsData.afternoon ? 'white' : 'black',
                                        backgroundColor: objTcsData.afternoon ? 'blue' : 'white',
                                    }
                                }}><Button size="small" onClick={(e) => {handleDetail('afternoon')}} sx={buttonShortStyle}>昼</Button></Box>
                                <Box sx={{
                                    '& .MuiButton-root:hover': {
                                        color: objTcsData.night ? 'white' : 'black',
                                        backgroundColor: objTcsData.night ? 'blue' : 'white',
                                    },
                                    '& .MuiButton-root': {
                                        color: objTcsData.night ? 'white' : 'black',
                                        backgroundColor: objTcsData.night ? 'blue' : 'white',
                                    }
                                }}><Button size="small" onClick={(e) => {handleDetail('night')}} sx={buttonShortStyle}>夜</Button></Box>
                                <Box sx={{
                                    '& .MuiButton-root:hover': {
                                        color: objTcsData.holiday ? 'white' : 'black',
                                        backgroundColor: objTcsData.holiday ? 'blue' : 'white',
                                    },
                                    '& .MuiButton-root': {
                                        color: objTcsData.holiday ? 'white' : 'black',
                                        backgroundColor: objTcsData.holiday ? 'blue' : 'white',
                                    }
                                }}><Button size="small" onClick={(e) => {handleDetail('holiday')}} sx={buttonStyle}>休日</Button></Box>
                                <Box sx={{
                                    '& .MuiButton-root:hover': {
                                        color: objTcsData.morningSpecific ? 'white' : 'black',
                                        backgroundColor: objTcsData.morningSpecific ? 'blue' : 'white',
                                    },
                                    '& .MuiButton-root': {
                                        color: objTcsData.morningSpecific ? 'white' : 'black',
                                        backgroundColor: objTcsData.morningSpecific ? 'blue' : 'white',
                                    }
                                }}><Button size="small" onClick={(e) => {handleDetail('morningSpecific')}} sx={buttonStyle}>朝特定</Button></Box>
                                <Box sx={{
                                    '& .MuiButton-root:hover': {
                                        color: objTcsData.afternoonSpecific ? 'white' : 'black',
                                        backgroundColor: objTcsData.afternoonSpecific ? 'blue' : 'white',
                                    },
                                    '& .MuiButton-root': {
                                        color: objTcsData.afternoonSpecific ? 'white' : 'black',
                                        backgroundColor: objTcsData.afternoonSpecific ? 'blue' : 'white',
                                    }
                                }}><Button size="small" onClick={(e) => {handleDetail('afternoonSpecific')}} sx={buttonStyle}>昼特定</Button></Box>
                                <Box sx={{
                                    '& .MuiButton-root:hover': {
                                        color: objTcsData.nightSpecific ? 'white' : 'black',
                                        backgroundColor: objTcsData.nightSpecific ? 'blue' : 'white',
                                    },
                                    '& .MuiButton-root': {
                                        color: objTcsData.nightSpecific ? 'white' : 'black',
                                        backgroundColor: objTcsData.nightSpecific ? 'blue' : 'white',
                                    }
                                }}><Button size="small" onClick={(e) => {handleDetail('nightSpecific')}} sx={buttonStyle}>夜特定</Button></Box>
                            </Box>
                        </Box>
                        <Box sx={openDetailItemsWidthSize()}>
                            <Typography
                                onClick={(e) => {handleDetailItems()}}
                            >詳細表示▼</Typography>
                            <Box sx={{
                                display: openDetailItems ? 'flex' : 'none',
                                width: openDetailItems && tilt ? Math.floor(viewDetails * 1.5) : viewDetails
                            }}>
                                <Box sx={{
                                    '& .MuiButton-root:hover': {
                                        color: objTcsData.carItem ? 'white' : 'black',
                                        backgroundColor: objTcsData.carItem ? 'green' : 'white',
                                    },
                                    '& .MuiButton-root': {
                                        color: objTcsData.carItem ? 'white' : 'black',
                                        backgroundColor: objTcsData.carItem ? 'green' : 'white',
                                    }
                                }}>
                                    <Button size="small" onClick={(e) => {handleDetail('car')}} sx={{
                                        minWidth: 0,
                                        padding: "2px 12px",
                                        margin: '2px 4px',
                                        border: '1px solid green',
                                    }}>車</Button>
                                </Box>
                                <Box sx={{
                                    '& .MuiButton-root:hover': {
                                        color: objTcsData.personItem ? 'white' : 'black',
                                        backgroundColor: objTcsData.personItem ? 'green' : 'white',
                                    },
                                    '& .MuiButton-root': {
                                        color: objTcsData.personItem ? 'white' : 'black',
                                        backgroundColor: objTcsData.personItem ? 'green' : 'white',
                                    }
                                }}>
                                    <Button size="small" onClick={(e) => {handleDetail('person')}} sx={{
                                        minWidth: 0,
                                        padding: "2px 10px",
                                        margin: '2px 4px',
                                        border: '1px solid green',
                                    }}>人</Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={{
                margin: '6px',
                width:  tableWidth,
            }}>
                <TableContainer sx={{
                    height: tableHeight,
                    minHeight: tableHeight,
                    maxHeight: tableHeight,
                    overflowX: 'auto',
                    overflowY: 'auto',
                    border: '2px solid #000',
                    '&-webkit-overflow-scrolling': 'touch',
                    '& .MuiTableCell-root': {
                        margin: '6px',
                        padding: 0,
                    },
                    '& .MuiTypography-root': {
                        fontSize: '0.8rem',
                    },
                }}>
                    <Table sx={{
                        borderCollapse: 'separate',
                        width: '100%',
                        '& .MuiTableCell-root': {
                            textAlign: 'center'
                        },
                        ".MuiTableCell-head,.MuiTableCell-body": {
                            padding: "4px 6px",
                        },
                    }}>
                        <TableHead sx={headerRowStyle}>
                            <TableRow>
                                <TableCell rowSpan={2} sx={headCrossStyle({ width: 60 })}>調査<br />日時</TableCell>
                                {
                                    objTcsData.carItem &&
                                    <>
                                        <TableCell colSpan={4}  sx={headColStyle({ width: 244, bl: false, bb: false})} >前面</TableCell>
                                        <TableCell colSpan={4}  sx={headColStyle({ width: 244, bl: true, bb: false})} >側面</TableCell>
                                        <TableCell colSpan={3}  sx={headColStyle({ width: 192, bl: true, bb: false})} >側面</TableCell>
                                        <TableCell colSpan={3}  sx={headColStyle({ width: 192, bl: true, bb: false})} >裏道</TableCell>
                                    </>
                                }
                                {
                                    objTcsData.personItem &&
                                    <>
                                        <TableCell rowSpan={2} sx={headColStyle({ width: 70, bl: true, bb: true})}>中高生</TableCell>
                                        <TableCell colSpan={2} sx={headColStyle({ width: 120, bl: false})}>65歳以上</TableCell>
                                        <TableCell colSpan={2} sx={headColStyle({ width: 120, bl: false})}>その他</TableCell>
                                        <TableCell rowSpan={2} sx={headColStyle({ width: 70, bl: false, bb: true})}>合計</TableCell>
                                        <TableCell rowSpan={2} sx={headColStyle({ width: 70, bl: false, bb: true})}>内<br />自転車</TableCell>
                                    </>
                                }
                            </TableRow>
                            <TableRow>
                                {
                                    objTcsData.carItem &&
                                    <>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>渋滞<br />（分）</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>総<br />台数</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>内<br />軽</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>内<br />大型</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: true, bb: true})}>渋滞<br />（分）</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>総<br />台数</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>内<br />軽</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>内<br />大型</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: true, bb: true})}>総<br />台数</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>内<br />軽</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>内<br />大型</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: true, bb: true})}>総<br />台数</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>内<br />軽</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>内<br />大型</TableCell>
                                    </>
                                }
                                {
                                    objTcsData.personItem &&
                                    <>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>男</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>女</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>男</TableCell>
                                        <TableCell sx={headColStyle({ width: 60, bl: false, bb: true})}>女</TableCell>
                                    </>
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {datarows?.map((row: any) => (
                                <TableRow key={row.id} sx={{
                                    borderBottom: '1px solid #000',
                                    '& .MuiTableCell-root': {
                                        borderBottom: '1px solid #000',
                                    }
                                }}>
                                    <TableCell sx={rowCrossStyle({ br: true })}>{row.count_date}<br />{row.count_time_display}</TableCell>
                                    {
                                        objTcsData.carItem &&
                                        <>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.front_traffic_jam_time}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.frontTotal}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.car_front_light}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.car_front_large}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: true})}>{row.side_a_traffic_jam_time}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.car_side_a_total}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.car_side_a_light}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.car_side_a_large}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: true})}>{row.car_side_b_total}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.car_side_b_total}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.car_side_b_large}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: true})}>{row.car_back_total}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.car_back_light}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.car_back_large}</TableCell>
                                        </>
                                    }
                                    {
                                        objTcsData.personItem &&
                                        <>
                                            <TableCell sx={rowColStyle({ width: 60, bl: true})}>{row.student}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.male_65over}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.female_65over}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.male_other}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.female_other}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.total_people}</TableCell>
                                            <TableCell sx={rowColStyle({ width: 60, bl: false})}>{row.bicycle}</TableCell>
                                        </>
                                    }
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <ConfirmDialog props={{
                open: errorDialogOpen,
                handleModal: setErrorDialogOpen,
                onCancel: () => {},
                onExecution: () => {},
                onCancelRegist: () => {},
                mode: "",
                body: LOCAL_CONSTANT.ERROR_MESSAGE.PLAN_AREA_ID_NOT_FOUND,
                confirmCancel: "",
                confirmOk: "",
                confirmCancelRegist: "",
            }} />
        </Box>

    )
}


export default TrafficConfirmationScreen
